// extracted by mini-css-extract-plugin
export default {"optionsWrapper":"styles_optionsWrapper__SOWy3","optionsDots":"styles_optionsDots__5lcyk","options":"styles_options__hefxH","item":"styles_item__u6mTI","icon":"styles_icon__N-8d0"};